import { render, staticRenderFns } from "./TransferCoupon.vue?vue&type=template&id=1bfb37cf&scoped=true&"
import script from "./TransferCoupon.vue?vue&type=script&lang=js&"
export * from "./TransferCoupon.vue?vue&type=script&lang=js&"
import style0 from "../../less/transfer.less?vue&type=style&index=0&id=1bfb37cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb37cf",
  null
  
)

export default component.exports